import { all, fork } from 'redux-saga/effects';

import ImageComparisonSagas from './imageComparison/sagas';

export default function* attachmentsSagas() {
  yield all([fork(ImageComparisonSagas)]);
}
